import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "joy-input-group" }
const _hoisted_2 = { class: "joy-input-group" }

import Autocomplete from '@malt/joy-entrypoint/src/vue/Autocomplete.vue';
    import DraggableSkills from '@/common/components/DraggableSkills.vue';
    import SuggestionsSkills from '@/common/components/SuggestionsSkillsV2.vue';
    import {Skill} from '@/common/types/Skill';
    import {useSkills} from '@/common/composable/useSkills';
    import {computed, watchEffect, PropType} from 'vue';
    import {FreelancerSkillsService} from '@/common/api/FreelancerSkillsService';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectProposalSkillsField',
  props: {
        initialSkills: Array,
        category: String,
        jobTitle: String,
        freelancerSkillsService: {type: Object as PropType<FreelancerSkillsService>, required: true},
    },
  emits: ["suggestedSkillsFetched", "update"],
  setup(__props, { emit: __emit }) {

    const props = __props;

    const {skills, valueChanged, onSkillAdded, updateSkills, maxSkills, suggestedSkills, getSuggestedSkills, isThereTooMuchSkills, isMaxSkills} =
        useSkills((props.initialSkills as Skill[]) || [], props.freelancerSkillsService);

    const isSuggestionsSkillsSelectable = computed(() => !isMaxSkills.value && !isThereTooMuchSkills.value);

    const emit = __emit;
    async function fetchSuggestedSkills() {
        if (props.freelancerSkillsService && props.category) {
            const [data, error] = await getSuggestedSkills(props.category, props.jobTitle || null);

            if (data && !error) {
                emit('suggestedSkillsFetched');
            }
        }
    }

    watchEffect(() => fetchSuggestedSkills());

return (_ctx: any,_cache: any) => {
  const _component_joy_label = _resolveComponent("joy-label")!
  const _component_joy_form_error = _resolveComponent("joy-form-error")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$msg('customer.brief.form.freelancer.skills.subtitle')), 1),
      _createVNode(Autocomplete, {
        "data-testid": "project-proposal-autocomplete-skills-selection",
        "autocomplete-service": props.freelancerSkillsService,
        "clear-search-after-selection": "",
        placeholder: _ctx.$msg('customer.brief.form.freelancer.skills.autocomplete.placeholder'),
        "onUpdate:modelValue": _unref(valueChanged)
      }, {
        default: _withCtx((slotProps) => [
          _createTextVNode(_toDisplayString(slotProps.option.name), 1)
        ]),
        _: 1
      }, 8, ["autocomplete-service", "placeholder", "onUpdate:modelValue"]),
      _createVNode(SuggestionsSkills, {
        skills: _unref(suggestedSkills),
        label: _ctx.$msg('customer.brief.form.freelancer.skills.suggest'),
        selectable: isSuggestionsSkillsSelectable.value,
        onSelect: _unref(onSkillAdded)
      }, null, 8, ["skills", "label", "selectable", "onSelect"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_joy_label, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.freelancer.skills.label')), 1)
        ]),
        _: 1
      }),
      _createVNode(DraggableSkills, {
        skills: _unref(skills),
        "max-count": _unref(maxSkills),
        "placeholder-count": 2,
        "show-remove-button": true,
        onChange: _unref(updateSkills)
      }, null, 8, ["skills", "max-count", "onChange"]),
      (_unref(isThereTooMuchSkills))
        ? (_openBlock(), _createBlock(_component_joy_form_error, {
            key: 0,
            "no-html-error-text": _ctx.$msg('project.proposal.skills.field.error.max.skills', _unref(maxSkills))
          }, null, 8, ["no-html-error-text"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})